const appSettingsLoader = {
	ApplicationSettings: null,
	init: async () => await appSettingsLoader.loadApplicationSettings(),
	beforeEnter: (to, from, next) => {
		appSettingsLoader
			.loadApplicationSettings()
			.then(() => {
				next();
			})
			.catch(error => {
				next(false);
			});
	},
	loadApplicationSettings: async () => {
		if (!appSettingsLoader.ApplicationSettings) appSettingsLoader.ApplicationSettings = (await import('@core/classes/Applications/ApplicationsSettings')).default;
		return appSettingsLoader.ApplicationSettings;
	},
};

export default appSettingsLoader;
